<template>
    <div>
        <div v-if="subMsgComputed.content_type == 'note'" @click="handleGoDetail(subMsgComputed.link)" style="cursor: pointer;">
            <div class="img_c">
                <img :src="subMsgComputed.cover" @error="e => { e.target.src = defaultImage }"/>
            </div>
            <div class="msg_c mt_10" style="color:blue;">
                {{ msgItem.msg }}
            </div>

        </div>
        <div v-else-if="subMsgComputed.content_type == 'common'" @click="handleGoDetail(subMsgComputed.link)" style="cursor: pointer;">
            <div class="img_c">
                <img :src="subMsgComputed.cover" @error="e => { e.target.src = defaultImage }"/>
            </div>
            <div class="msg_c mt_10" style="color:blue;">
                {{ msgItem.msg }}
            </div>
        </div>
        <div v-else>
            <div class="img_c">
                <img :src="subMsgComputed.image" @error="e => { e.target.src = defaultImage }"/>
            </div>
            <div class="msg_c mt_10">
                {{ msgItem.msg }}
            </div>

        </div>
    </div>
</template>
<script>
// 引入动态组件（中间栏）
import { toRefs, onMounted, reactive, computed, inject } from "vue";
import defaultImage from '@/assets/img/error_icon.jpg'
export default {
    components: {},
    setup() {
        const $tauriWindow = inject('tauriWindow')
        const msgItem = inject('msgItem')
        const data = reactive({

        });
        const subMsgComputed = computed(() => {
            try {
                return JSON.parse(msgItem?.submsg)
            } catch (e) {
                console.error(e)
                return {}
            }
        })
        // ----------- 方法 -----------
        const handleGoDetail = (url) => {
            if(!url){
                return
            }
            $tauriWindow.openWindow(url)
        }

        onMounted(() => { });


        return {
            ...toRefs(data),
            msgItem,
            subMsgComputed,
            defaultImage,
            handleGoDetail
        };
    },
};
</script>

<style lang="scss" scoped>
.img_c {
    display: flex;
    justify-content: flex-end;
}

.img_c img {

    width: 200px;
    height: 200px;
    object-fit: fill;
}

.msg_c {
    display: flex;
    justify-content: center;
}
</style>